<div class="header flex">
  <div class="header_logo">
    <img
      (click)="navigateToHome()"
      (keydown.enter)="navigateToHome()"
      src="assets/logo/JUSTSEXT.svg"
      class="header_logo__img"
      alt="justsext"
      tabindex="-1"
    />
  </div>
  <div class="header_nav">
    <stxt-navigation-bar></stxt-navigation-bar>
  </div>
  <ng-container *ngIf="$isUser | async">
    <a
      (click)="setProfileIntent(EProfileTab.Wallet, $event)"
      (keydown.enter)="setProfileIntent(EProfileTab.Wallet, $event)"
      [ngClass]="{ 'gradient-border': tokenType === ETokenType.Add }"
      class="flex profile_nav relative"
      tabindex="0"
    >
      <stxt-token-status
        [tokensBalance]="tokensBalance"
        (tokenType)="getTokenType($event)"
        [usageCase]="ETokenUsageCase.Header"
      ></stxt-token-status>
      <button (click)="setProfileIntent(EProfileTab.Account, $event)" class="btn-nostyle">
        <div class="profile-svg_wrapper">
          <stxt-svg-icon class="header_icon" [iconConfig]="profileSvg"></stxt-svg-icon>
        </div>
      </button>
    </a>
  </ng-container>
  <ng-container *ngIf="($isUser | async) === false">
    <div class="header_nav__auth flex">
      <a
        class="header_nav__auth-item flex login_nav"
        (click)="openAuth(EAuthType.Login, EAuthButtonText.Login)"
        (keydown.enter)="openAuth(EAuthType.Login, EAuthButtonText.Login)"
        tabindex="0"
      >
        <span class="auth-button margin-none">{{ EAuthButtonText.Login }}</span>
      </a>
      <a
        class="header_nav__auth-item flex sign-up_nav flex items-center"
        (click)="openAuth(EAuthType.SignUp, EAuthButtonText.SignUp)"
        (keydown.enter)="openAuth(EAuthType.SignUp, EAuthButtonText.SignUp)"
        tabindex="0"
      >
        <span class="auth-button margin-none">{{ EAuthButtonText.SignUp }}</span>
      </a>
    </div>
  </ng-container>
</div>

<ng-container *ngIf="showProfileFlyout && showDropdown">
  <stxt-profile-flyout
    [selectedTab]="openProfileIntent"
    [getTokensScreen]="getTokensScreen"
    (closeDropdown)="openProfile($event)"
  ></stxt-profile-flyout>
</ng-container>
